import { ToastAction, ToastActionType, ToastProps } from './Toast.types';
import { ReactNode } from 'react';

export const toast: {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  [key in NonNullable<ToastProps['motif']>]: (
    content: any,
    title?: ReactNode,
    options?: ToastProps,
  ) => ToastAction;
} = {
  success: (content, title, options) =>
    addToast({ ...options, motif: 'success', content, title }),
  warning: (content, title, options) =>
    addToast({ ...options, motif: 'warning', content, title }),
  error: (content, title, options) =>
    addToast({ ...options, motif: 'error', content, title }),
  info: (content, title, options) =>
    addToast({ ...options, motif: 'info', content, title }),
};

export function addToast(payload: ToastProps): ToastAction {
  return { type: ToastActionType.ADD_TOAST, payload };
}

export function removeToast(payload: string | undefined): ToastAction {
  return { type: ToastActionType.REMOVE_TOAST, payload };
}
